import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUsersComponent } from "./med-icon-users.component";

@NgModule({
  declarations: [
    MedIconUsersComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUsersComponent,
  ],
})
export class MedIconUsersModule { }
